import { useCallback } from "react"

import { useTransportMutation, useTransportQueryUtils } from "@/transport"

import type { EditableTestCase } from "../model"

export function usePersistExpectedBehaviors() {
  const updateTestCaseMutation = useTransportMutation("updateTestCaseRow")
  const queryUtils = useTransportQueryUtils()

  return useCallback(
    async (testCase: EditableTestCase) => {
      await updateTestCaseMutation.mutateAsync({
        test_case_id: testCase.id,
        input_str: testCase.input_str,
        expected_behaviors: testCase.expected_behaviors,
      })
      void queryUtils.invalidateResource("test-sets-rows")
    },
    [queryUtils, updateTestCaseMutation],
  )
}
